// Paleta bruta do Clixy em oklch. Roxo-violeta como primária, neutros levemente
// tingidos de roxo (é o que dá o ar lavanda do fundo em vez de cinza morto) e
// quatro acentos para estado e categorização.
//
// Nada aqui é semântico: `primary600` diz a cor, não o uso. O mapeamento para
// uso ("fundo do botão primário") vive em theme.ts.

export const purple = {
  50: 'oklch(0.975 0.012 288)',
  100: 'oklch(0.945 0.028 288)',
  200: 'oklch(0.895 0.055 288)',
  300: 'oklch(0.820 0.095 288)',
  400: 'oklch(0.715 0.155 287)',
  500: 'oklch(0.625 0.205 286)',
  600: 'oklch(0.565 0.225 285)',
  700: 'oklch(0.495 0.210 285)',
  800: 'oklch(0.425 0.175 285)',
  900: 'oklch(0.365 0.140 285)',
  950: 'oklch(0.255 0.095 285)',
} as const;

export const neutral = {
  0: 'oklch(1 0 0)',
  50: 'oklch(0.985 0.004 288)',
  100: 'oklch(0.965 0.008 288)',
  200: 'oklch(0.925 0.010 288)',
  300: 'oklch(0.875 0.012 288)',
  400: 'oklch(0.715 0.015 286)',
  500: 'oklch(0.590 0.016 286)',
  600: 'oklch(0.490 0.017 286)',
  700: 'oklch(0.395 0.018 286)',
  800: 'oklch(0.285 0.018 285)',
  900: 'oklch(0.210 0.016 285)',
  950: 'oklch(0.155 0.014 285)',
} as const;

export const coral = {
  100: 'oklch(0.940 0.035 22)',
  200: 'oklch(0.885 0.070 22)',
  400: 'oklch(0.760 0.135 22)',
  500: 'oklch(0.675 0.170 22)',
  600: 'oklch(0.600 0.180 22)',
  700: 'oklch(0.515 0.165 22)',
} as const;

export const amber = {
  100: 'oklch(0.960 0.045 85)',
  200: 'oklch(0.915 0.085 82)',
  400: 'oklch(0.845 0.125 80)',
  500: 'oklch(0.790 0.140 78)',
  600: 'oklch(0.700 0.135 70)',
  700: 'oklch(0.585 0.115 65)',
} as const;

export const mint = {
  100: 'oklch(0.950 0.035 162)',
  200: 'oklch(0.900 0.065 162)',
  400: 'oklch(0.810 0.110 161)',
  500: 'oklch(0.740 0.125 160)',
  600: 'oklch(0.650 0.120 159)',
  700: 'oklch(0.545 0.105 158)',
} as const;

export const sky = {
  100: 'oklch(0.950 0.030 240)',
  200: 'oklch(0.900 0.055 240)',
  400: 'oklch(0.790 0.100 240)',
  500: 'oklch(0.705 0.125 242)',
  600: 'oklch(0.615 0.145 245)',
  700: 'oklch(0.520 0.135 248)',
} as const;

export const palette = { purple, neutral, coral, amber, mint, sky } as const;
